import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { DeliveryListDateState } from "../OrderDeliveryList"
import { useDateTime } from "../../../../../../localization/useDateTime"

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: "3.75rem 3.75rem 4.375rem",
        "@media print": {
            padding: 0,
            paddingBottom: "1rem",
        },
    },
    period: {
        color: theme.palette.tailwind.slate[700],
        fontSize: "1.25rem",
        fontWeight: 500,
    },
    title: {
        color: theme.palette.tailwind.slate[700],
        fontSize: "2.25rem",
        fontWeight: 500,
    },
}))

type DeliveryListHeaderProps = Readonly<{
    dateState: DeliveryListDateState
    label: string
    showPeriodAll?: boolean
}>

export function DeliveryListHeader({ dateState, label, showPeriodAll }: DeliveryListHeaderProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const startLabel = dateState.startDate ? dateTimeFactory.formatDate(dateState.startDate) : ""
    const endLabel = dateState.endDate ? dateTimeFactory.formatDate(dateState.endDate) : ""

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" className={classes.root}>
            <Typography variant="h6" className={classes.title}>
                {label}
            </Typography>
            {showPeriodAll ? (
                <LocalizedStrict id="meeting-service-delivery-list-header-period-all">
                    <Typography variant="body1" className={classes.period}>
                        Period: All
                    </Typography>
                </LocalizedStrict>
            ) : (
                <LocalizedStrict id="meeting-service-delivery-list-header-period" vars={{ startLabel, endLabel }}>
                    <Typography variant="body1" className={classes.period}>
                        Period: {startLabel} - {endLabel}
                    </Typography>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
